// Fix only the category row; its section wrapper must keep scrolling away.
(function () {
  function init(root) {
    root.querySelectorAll('[data-sticky-menu]:not([data-sticky-ready])').forEach(function (nav) {
      nav.dataset.stickyReady='true';
      var spacer=document.createElement('div');spacer.className='menu-spacer';nav.before(spacer);
      var row=nav.querySelector(':scope > .in'),frame;
      function update(){
        frame=null;
        var height=row.getBoundingClientRect().height+1;
        var pinned=spacer.getBoundingClientRect().top<0;
        spacer.style.height=pinned?height+'px':'0px';
        nav.classList.toggle('is-menu-sticky',pinned);
        nav.style.setProperty('--menu-height',height+'px');
        nav.style.setProperty('--menu-available',Math.max(0,innerHeight-Math.max(0,nav.getBoundingClientRect().top)-height)+'px');
        document.documentElement.style.setProperty('--sticky-menu-height',pinned?height+'px':'0px');
      }
      function schedule(){if(!frame)frame=requestAnimationFrame(update);}
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule);
      var observer=new ResizeObserver(schedule);observer.observe(row);update();
      function unload(event){if(!event.target.contains(nav))return;
        observer.disconnect();cancelAnimationFrame(frame);window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);
        document.documentElement.style.removeProperty('--sticky-menu-height');spacer.remove();document.removeEventListener('shopify:section:unload',unload);
      }
      document.addEventListener('shopify:section:unload',unload);
    });
  }
  init(document);document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
